import { render } from "./page_2.vue?vue&type=template&id=5f4d756a&scoped=true"
import script from "./page_2.vue?vue&type=script&lang=js"
export * from "./page_2.vue?vue&type=script&lang=js"

import "./page_2.vue?vue&type=style&index=0&id=5f4d756a&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4d756a"]])

export default __exports__